import {Component, OnInit, ViewChild} from '@angular/core';


@Component({
    templateUrl: './nosql-client.component.html',
    styleUrls: ['./nosql-client.component.scss']
})
export class NosqlClientComponent implements OnInit {
    fullPage: boolean;
    @ViewChild('iframe', {static: true}) iframe: any;

    constructor() {
    }

    ngOnInit(): void {
        this.fullPage = false;
        this.reloadPage();
    }

    toggleFullPage() {
        this.fullPage = !this.fullPage;
    }

    reloadPage() {
        this.iframe.nativeElement.src = '/nosqlclient/databaseStats';
    }
}
